import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'math-not', 'IconMathNot', [["path",{"d":"M5 12h14v4","key":"svg-0"}]]);